import gql from 'graphql-tag';

export const USER_QUERY = gql`
    query fetchUser {
        user {
            loggedIn
            name
            email
            status
            senderPropertyStatus
            userId
            userUuid
            creationDate
            brandPrimary
            registrationSources
        }
    }
`;
